import classNames from 'classnames'
import { format } from 'date-fns'
import { parseDate } from '../../helpers'
import { ReportPeriodRange } from '../../redux-toolkits/reports/reports.type'
import { TabNav } from '../nav/tabNav'
import { DateRangePicker } from './dateRange'
import Dropdown from './dropdown'

type DashboardReportRange = ReportPeriodRange | 'custom'

const periods: {
  name: string
  id: DashboardReportRange
}[] = [
  {
    name: 'Today',
    id: 'today',
  },
  {
    name: 'This week',
    id: 'this_week',
  },
  {
    name: 'MTD',
    id: 'this_month',
  },
  {
    name: 'YTD',
    id: 'this_year',
  },
  {
    name: 'ITD',
    id: 'inception_to_date',
  },
]

export const DateFilterNav = ({
  filter,
  isCustomDateRange,
  endDate,
  startDate,
  setFilter,
  className,
}: {
  filter: DashboardReportRange
  isCustomDateRange: boolean
  endDate?: string
  startDate?: string
  setFilter: (data: {
    filter?: ReportPeriodRange
    isCustomDateRange: boolean
    endDate?: string
    startDate?: string
  }) => void
  className?: string
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      <TabNav
        activeTab={filter}
        setActiveTab={(selected) => {
          const filter = selected as DashboardReportRange

          if (filter !== 'custom') {
            setFilter({
              filter: filter,
              isCustomDateRange: false,
              endDate: undefined,
              startDate: undefined,
            })
          }
        }}
        tabs={periods}
        type="switcher-outline"
        size="small"
        className="w-max"
      />

      <Dropdown
        menuButton={
          <p
            className={classNames(
              'text-xs border py-[10px] px-3 rounded-md font-medium',
              {
                'text-sec-black border-transparent ': !isCustomDateRange,
                'text-primary border-primary': isCustomDateRange,
              },
            )}
          >
            {isCustomDateRange
              ? `${format(startDate ?? '', 'do MMM')} - ${format(
                  endDate ?? '',
                  'do MMM',
                )}`
              : 'Custom'}
          </p>
        }
        menuClassName="!min-w-max !border-[0px]"
        customMenuItems={
          <DateRangePicker
            required
            navLayout="around"
            animate
            mode="range"
            selected={{
              from: parseDate(startDate)?.toDate() ?? undefined,
              to: parseDate(endDate)?.toDate() ?? undefined,
            }}
            onSelect={(selected) => {
              if (selected?.from && selected?.to) {
                setFilter({
                  filter: undefined,
                  startDate: selected?.from
                    ? format(selected?.from, 'yyyy-MM-dd')
                    : undefined,
                  endDate: selected?.to
                    ? format(selected?.to, 'yyyy-MM-dd')
                    : undefined,
                  isCustomDateRange: true,
                })
              }
            }}
            numberOfMonths={2}
            disabled={{ after: new Date() }}
          />
        }
      />
    </div>
  )
}
